import { useToast as usePrimeVueToast } from "primevue/usetoast";


export function useToast() {
  const toast = usePrimeVueToast()
  return toast
}